/* eslint-disable camelcase -- Metric tag names are external SignalFx dimensions. */

const DISABLED_METRIC_TAG_VALUE = 'disabled';

const HIGH_CARDINALITY_METRIC_TAG_OVERRIDE_NAME_LIST = [
	// Use `environment` for rollout scope; deployment IDs churn on every deploy.
	'deployment_id',
	// Use commit/deployment tracker data when version-level diagnosis is needed.
	'micros_service_version',
	// Use `environment`, which already carries the regional production/staging split.
	'region',
	// Use service and environment tags instead of collector topology.
	'gostatsd_cluster',
	// Use `ic` when service-instance identity is required.
	'micros_service_id',
	// Use `environment` for runtime slicing and ownership tools for business metadata.
	'business_unit',
	// Use `environment` for regional placement instead of zone-level fan-out.
	'micros_zone',
	// Use the metric namespace or service metadata instead of repeating the archetype.
	'archetype_id',
	// Use the metric namespace, which already scopes these metrics to Post Office.
	'service_name',
	// Use `perimeter` for operational impact grouping.
	'impact_level',
	// Use service ownership metadata outside the metric series.
	'resource_owner',
	// Use telemetry configuration outside the metric series.
	'obs_sfx_enable',
	// Use `micros_group` when container-level grouping is needed.
	'container_name',
	// Use `micros_group` or `environment` for infrastructure class grouping.
	'compute_type',
] as const;

type HighCardinalityMetricTagOverrideValue = typeof DISABLED_METRIC_TAG_VALUE;

export type HighCardinalityMetricTagOverrideName =
	(typeof HIGH_CARDINALITY_METRIC_TAG_OVERRIDE_NAME_LIST)[number];

export type HighCardinalityMetricTagOverrides = Readonly<
	Record<HighCardinalityMetricTagOverrideName, HighCardinalityMetricTagOverrideValue>
>;

export const HIGH_CARDINALITY_METRIC_TAG_OVERRIDES: HighCardinalityMetricTagOverrides =
	Object.freeze(
		Object.fromEntries(
			HIGH_CARDINALITY_METRIC_TAG_OVERRIDE_NAME_LIST.map((tagName) => [
				tagName,
				DISABLED_METRIC_TAG_VALUE,
			]),
		) as Record<HighCardinalityMetricTagOverrideName, HighCardinalityMetricTagOverrideValue>,
	) satisfies HighCardinalityMetricTagOverrides;
